<form class="requotation-dialog" [formGroup]="quoteFG" (ngSubmit)="quoteFG.valid && quote()">
    <button mat-icon-button type="button" class="close-dialog-button" (click)="cerrarDialogo()">
        <mat-icon>close</mat-icon>
    </button>
    <span class="dialog-title">
        Volver a cotizar
    </span>
    <span class="dialog-description">
        Al volver a cotizar se acutalizará la garantía con el resultado de la nueva cotización.
    </span>
    <div class="horizontal-layout">
        <div class="property-settings">
            <span class="subsection-title">
                Datos de la propiedad
            </span>
            <mat-radio-group class="form-radio-line" formControlName="tipo" color="primary">
                <span class="radio-line-label">
                    Tipo de propiedad
                </span>
                <div class="radios">
                    <mat-radio-button *ngFor="let type of quoteTypes" [value]="type.codigo" [disabled]="warranty.propiedad && warranty.propiedad.tipo !== type.codigo && warranty.propiedad.tipo !== 'AMBOS'">{{ type.descripcion }}</mat-radio-button>
                </div>
            </mat-radio-group>
            <div class="form-line">
                <mat-form-field class="garantor-form-field" appearance="outline">
                    <mat-label>Alquiler</mat-label>
                    <input matInput formControlName="alquiler" type="number">
                    <span matPrefix>$ &nbsp;</span>
                    <mat-error *ngIf="quoteFG.controls['alquiler'].hasError('required')">
                        Por favor ingrese el alquiler
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="garantor-form-field" appearance="outline">
                    <mat-label>Expensas</mat-label>
                    <input matInput formControlName="expensas" type="number">
                    <span matPrefix>$ &nbsp;</span>
                    <mat-error *ngIf="quoteFG.controls['expensas'].hasError('required')">
                        Por favor ingrese las expensas
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="form-line" *ngIf="quoteFG.value.tipo === 'COMERCIAL'">
                <mat-form-field class="garantor-form-field" appearance="outline">
                    <mat-label>Porcentaje de actualización</mat-label>
                    <input matInput formControlName="actualizacion" type="number" style="text-align: right;">
                    <span matSuffix>&nbsp; %</span>
                    <mat-error *ngIf="quoteFG.controls['actualizacion'].hasError('required')">
                        Por favor ingrese el porcentaje de actualización
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="garantor-form-field" appearance="outline">
                    <mat-label>Periodo de actualización</mat-label>
                    <mat-select formControlName="periodoActualizacion">
                        <mat-option *ngFor="let period of updatePeriods" [value]="period.codigo">
                            {{ period.descripcion }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="quoteFG.controls['periodoActualizacion'].hasError('required')">
                        Por favor seleccione el periodo de actualización
                    </mat-error>
                </mat-form-field>
            </div>
            <mat-form-field class="garantor-form-field" appearance="outline">
                <mat-label>Plazo</mat-label>
                <mat-select formControlName="duracion">
                    <mat-option *ngFor="let term of terms" [value]="term.codigo">{{ term.descripcion }}</mat-option>
                </mat-select>
                <mat-error *ngIf="quoteFG.controls.duracion.hasError('required')">
                    Por favor seleccione el plazo
                </mat-error>
            </mat-form-field>
        </div>
        <div class="services-selector">
            <span class="subsection-title">
                Servicios
            </span>
            <app-data-table
                [rows]="services"
                [columns]="serviceSelectorTableColumns"
                selectionType="multiple"
                [(selected)]="selectedServices"
                (selectedChange)="onServiceSelect()"
                [rowId]="rowId"
                [stickyHeader]="true"
                stickyHeaderBackground="white"
                height="360px"
                overflow="auto"
            ></app-data-table>
        </div>
    </div>
    <button mat-raised-button color="accent" class="garantor-button quote-button">Actualizar garantía</button>
</form>
